import React from "react";
import firebaseApi from "../../apis/firebaseApi";
import { FrameContext } from "../../contexts/FrameContext";
import dateHelpers from "../../helpers/dateHelpers";
import WorkHours from "../common/WorkHours";
import config from "../../apis/firebase.config";

const EditAgent = () => {
    const { companyId, agentId, source, isInFrame } = React.useContext(FrameContext);
    const [agent, setAgent] = React.useState();
    const [workHours, setWorkHours] = React.useState();
    const [timeZone, setTimeZone] = React.useState(dateHelpers.getTimeZoneOffset());
    const [duration, setDuration] = React.useState(30);
    const [name, setName] = React.useState("");
    const [email, setEmail] = React.useState("");

    const [hideName, setHideName] = React.useState(false);
    const [hideEmail, setHideEmail] = React.useState(false);

    React.useEffect(() => {
        if (!companyId || !agentId) return;
        firebaseApi.getAgent(companyId, agentId, data => {
            let agent = { ...data.data(), id: data.id };

            //if first time load
            if (!agent.gmtOffset || !agent.duration) {
                agent.gmtOffset = agent.gmtOffset || dateHelpers.getTimeZoneOffset();
                agent.duration = agent.duration || 30;
                firebaseApi.updateAgent(companyId, agentId, agent);
                firebaseApi.updateAgentScheduling(source.agentId, true, () => { });
            }

            setWorkHours(agent.workHours || null);
            setTimeZone(agent.gmtOffset || dateHelpers.getTimeZoneOffset());
            setDuration(agent.duration || 30);

            setName(agent.name || "");
            setEmail(agent.email || "");

            setHideName(!!agent.name);
            setHideEmail(!!agent.email);
            setAgent(agent);

            if (source.source === "connect") {
                firebaseApi.getAgentById(source.agentId, data => {
                    firebaseApi.getOrCreateLocation(companyId, { source: source.source, id: data.location }, null, l => {
                        let d = { name: data.name, slug: data.slug, locationId: l.id };
                        firebaseApi.updateAgent(companyId, agentId, d, () => { });
                    })

                });
            }
        });
    }, [companyId, agentId]);

    const onSaveClick = () => {
        const saveData = { name: name, workHours: workHours, gmtOffset: Number(timeZone), duration: parseInt(duration) };
        firebaseApi.updateAgent(companyId, agentId, saveData, () => { })
    }

    const onWorkHoursChange = wh => {
        setWorkHours(wh);
        let days = Object.keys(wh.data);
        for (let i = 0; i <= 6; i++) {
            if (days.indexOf(i.toString()) < 0) {
                wh.data[i] = config.firebase.firestore.FieldValue.delete()
            }
        }
        firebaseApi.updateAgent(companyId, agentId, { workHours: wh }, () => { })
    }

    const onTimeZoneChange = e => {
        setTimeZone(e.target.value);
        firebaseApi.updateAgent(companyId, agentId, { gmtOffset: Number(e.target.value) }, () => { })
    }

    const onDurationChange = e => {
        setDuration(e.target.value);
        firebaseApi.updateAgent(companyId, agentId, { duration: parseInt(e.target.value) }, () => { })
    }

    const onDurationBlur = e => {
        firebaseApi.updateAgent(companyId, agentId, { duration: parseInt(e.target.value) }, () => { })
    }

    const onNameChange = e => {
        setName(e.target.value);
    }

    const onNameBlur = e => {
        firebaseApi.updateAgent(companyId, agentId, { name: name }, () => { })
    }

    const onEmailChange = e => {
        setEmail(e.target.value);
    }

    const onEmailBlur = e => {
        firebaseApi.updateAgent(companyId, agentId, { email: e.target.value }, () => { })
    }

    if (!agent) return null;

    return (
        <div className="pf-schedule-agent-edit">
            {/* {!isInFrame() && <h3 className="text-center">{hideName ? name : "Edit Profile"}</h3>} */}
            <div className="pf-schedule-form">
                {/* {
                    !hideName &&
                    <div className="form-group">
                        <label>Name:</label>
                        <input
                            type="text"
                            value={name}
                            onChange={onNameChange}
                            onBlur={onNameBlur}
                        />
                    </div>
                } */}
                {/* <div className="form-group">
                    <label>Email:</label>
                    <input
                        type="text"
                        value={email}
                        onChange={onEmailChange}
                        onBlur={onEmailBlur}
                    />
                </div> */}
                {/* <div className="form-group">
                    <label>Time Zone:</label>
                    <input
                        type="text"
                        value={timeZone}
                        onChange={onTimeZoneChange}
                    />
                </div> */}
                <h4>Availability</h4>
                <div className="form-group">
                    <label>Work Schedule:</label>
                    <WorkHours
                        workHours={workHours}
                        onChange={onWorkHoursChange}
                    />
                </div>
                <hr />
                <h4>Appointments</h4>
                <div className="form-group">
                    <label>Duration:</label>
                    <select
                        className="pf-schedule-select"
                        value={duration}
                        onChange={onDurationChange}>
                        <option value="15">15 minutes</option>
                        <option value="30">30 minutes</option>
                        <option value="60">1 hour</option>
                        <option value="120">2 hours</option>
                    </select>
                </div>
                {/* <div className="pf-schedule-save-container">
                    <button type="button" onClick={onSaveClick} className="pf-schedule-btn-save">Save</button>
                </div> */}
            </div>
        </div>
    );
}

export default EditAgent;